import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <div className="auth-layout-wrapper">
      <div className="auth-left">
        <div className="app-logo" />
      </div>
      <div className="auth-right">
        <div className="auth-form-wrapper">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
